import { APP_PREFIX_PATH } from 'configs/AppConfig'

import {
  DashboardOutlined,
  AppstoreOutlined,
  UserSwitchOutlined,
  FundOutlined,
  ProfileOutlined,
  IdcardOutlined,
  DatabaseFilled,
  DownloadOutlined,
  FileImageOutlined,
  TransactionOutlined,
  UsergroupAddOutlined,
  PrinterOutlined,
  FileProtectOutlined,
  PlusSquareOutlined
} from '@ant-design/icons';

const dashBoardNavTree = [{
  key: 'dashboards',
  path: `${APP_PREFIX_PATH}/dashboards`,
  title: 'sidenav.dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboards-home',
      path: `${APP_PREFIX_PATH}/dashboards/dashoard-User`,
      title: 'sidenav.dashboard.home',
      icon: FundOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-unit-statement',
      path: `${APP_PREFIX_PATH}/dashboards/unitStatement`,
      title: 'sidenav.dashboard.unitstatement',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-bhunit-statement',
      path: `${APP_PREFIX_PATH}/dashboards/bpunitStatement`,
      title: 'sidenav.dashboard.bhadaramunitstatement',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
  ]
}]

const appsNavTree = [{
  key: 'apps',
  path: `${APP_PREFIX_PATH}/apps`,
  title: 'sidenav.apps',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    // {
    //   key: 'apps-memers',
    //   path: `${APP_PREFIX_PATH}/apps/members`,
    //   title: 'sidenav.apps.members',
    //   icon: UserSwitchOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    {
      key: 'apps-memers-bhadram',
      path: `${APP_PREFIX_PATH}/apps/bhadram`,
      title: 'sidenav.apps.members.bhadram',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-bhadram-plus',
      path: `${APP_PREFIX_PATH}/apps/bhadram_plus`,
      title: 'sidenav.dashboard.bhadram_plus',
      icon: PlusSquareOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-memers',
      path: `${APP_PREFIX_PATH}/apps/members`,
      title: 'sidenav.apps.memberss',
      icon: UsergroupAddOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-members_directory',
      path: `${APP_PREFIX_PATH}/apps/directory`,
      title: 'sidenav.apps.member_directory',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-members_idCards',
      path: `${APP_PREFIX_PATH}/apps/idCard`,
      title: 'sidenav.apps.idCards',
      icon: IdcardOutlined,
      breadcrumb: false,
      submenu: []
    }
    // {
    //   key: 'apps-members_directory',
    //   path: `${APP_PREFIX_PATH}/apps/directory`,
    //   title: 'sidenav.apps.member_directory',
    //   icon: ProfileOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'apps-members_idCards',
    //   path: `${APP_PREFIX_PATH}/apps/idCard`,
    //   title: 'sidenav.apps.idCards',
    //   icon: IdcardOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // }
  ]
}]

const kshemanidhiNavTree = [{
  key: 'Kshemanidhi',
  path: `${APP_PREFIX_PATH}/Kshemanidhi`,
  title: 'sidenav.Kshemanidhi',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'Kshemanidhi-members',
      path: `${APP_PREFIX_PATH}/Kshemanidhi/members`,
      title: 'sidenav.Kshemanidhi.members',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'Kshemanidhi-pensioner',
      path: `${APP_PREFIX_PATH}/Kshemanidhi/pensions`,
      title: 'sidenav.Kshemanidhi.Pensioner',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const details = [{
  key: 'details',
  path: `${APP_PREFIX_PATH}/details`,
  title: 'sidenav.Details',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'details-news',
      path: `${APP_PREFIX_PATH}/details/news`,
      title: 'sidenav.Details.news',
      icon: DatabaseFilled,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-boardMembers',
      path: `${APP_PREFIX_PATH}/details/boardMembers`,
      title: 'sidenav.Details.boardMembers',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-downloads',
      path: `${APP_PREFIX_PATH}/details/downloads`,
      title: 'sidenav.Details.downloads',
      icon: DownloadOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-Gallery',
      path: `${APP_PREFIX_PATH}/details/gallery`,
      title: 'sidenav.Details.gallery',
      icon: FileImageOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const onlineTransaction = [{
  key: 'online',
  path: `${APP_PREFIX_PATH}/online`,
  title: 'sidenav.online',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'online-transaction',
      path: `${APP_PREFIX_PATH}/online/transactions`,
      title: 'sidenav.online.bdrm',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-bulk',
      path: `${APP_PREFIX_PATH}/online/bulk_payment`,
      title: 'sidenav.online.bulk',
      icon: TransactionOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...appsNavTree,
  ...onlineTransaction
]

export default navigationConfig;
